import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ErrorTryCatch from 'components/consumer/error-try-catch';
import classNames from 'classnames';
import MixedGridCard from './MixedGridCard';
import MixedGridCardPlaceholder from './MixedGridCardPlaceholder';
const MixedGridItemsWithReviews = t0 => {
  const $ = _c(20);
  const {
    loadingMore,
    data,
    hits,
    hoveredValue,
    layout,
    onHoverHandler,
    toggleModalView,
    isMixedGridTab,
    allStaticProductData: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const allStaticProductData = t2;
  let items;
  if ($[2] !== allStaticProductData || $[3] !== data || $[4] !== hits || $[5] !== hoveredValue || $[6] !== isMixedGridTab || $[7] !== layout || $[8] !== onHoverHandler || $[9] !== toggleModalView) {
    items = [];
    let photosList;
    let productsList;
    let reviewsList;
    if ($[11] !== data) {
      reviewsList = [];
      productsList = [];
      photosList = [];
      data.forEach(each => {
        if (each.card_type === "review") {
          reviewsList.push(each);
        } else {
          if (each.card_type === "product") {
            productsList.push(each);
          } else {
            if (each.card_type === "customer_photo") {
              photosList.push(each);
            }
          }
        }
      });
      $[11] = data;
      $[12] = photosList;
      $[13] = productsList;
      $[14] = reviewsList;
    } else {
      photosList = $[12];
      productsList = $[13];
      reviewsList = $[14];
    }
    let productIndex = 0;
    let photoIndex = 0;
    let reviewIndex = 0;
    let itemIndex = 0;
    while (productsList[productIndex] || photosList[photoIndex] || reviewsList[reviewIndex]) {
      if (productsList[productIndex] || photosList[photoIndex]) {
        const productCard = productsList[productIndex];
        const photoCard = photosList[photoIndex];
        if (productCard || photoCard) {
          const productData = productCard?.card_type === "product" ? allStaticProductData.find(product => parseInt(product.id, 10) === parseInt(productCard.id, 10)) : null;
          items.push(<div className={classNames("grid gap-[10px] max-[767px]:mt-2 md:gap-4 min-[1200px]:grid-cols-[repeat(auto-fit,minmax(300px,33.333%))] max-[767px]:[&>*]:max-w-[100vw]", {
            "xl:grid-cols-[repeat(auto-fit,minmax(45%,1fr))] xl:m-0": isMixedGridTab
          })} key={`grid-pair-${itemIndex}`}>{productCard && <ErrorTryCatch key={`prod-${itemIndex}-${productCard.id || productCard.card_type || itemIndex}`}><MixedGridCard {...productCard} index={productIndex} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} productData={productData} /></ErrorTryCatch>}{photoCard && <ErrorTryCatch key={`photo-${itemIndex}-${photoCard.id || photoCard.card_type || itemIndex}`}><MixedGridCard {...photoCard} index={photoIndex} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} /></ErrorTryCatch>}</div>);
          if (productCard) {
            productIndex++;
          }
          if (photoCard) {
            photoIndex++;
          }
          itemIndex++;
        }
      }
      if (reviewsList[reviewIndex]) {
        const reviewCard = reviewsList[reviewIndex++];
        items.push(<div className="flex flex-col" key={`review-container-${itemIndex}`}><ErrorTryCatch key={`review-${itemIndex}-${reviewCard.id || reviewCard.card_type || itemIndex}`}><MixedGridCard {...reviewCard} index={reviewIndex - 1} hits={hits} hoveredValue={hoveredValue} layout={layout} onHoverHandler={onHoverHandler} toggleModalView={toggleModalView} /></ErrorTryCatch></div>);
        itemIndex++;
      }
    }
    $[2] = allStaticProductData;
    $[3] = data;
    $[4] = hits;
    $[5] = hoveredValue;
    $[6] = isMixedGridTab;
    $[7] = layout;
    $[8] = onHoverHandler;
    $[9] = toggleModalView;
    $[10] = items;
  } else {
    items = $[10];
  }
  const gridItems = items;
  let t3;
  if ($[15] !== loadingMore) {
    t3 = loadingMore ? <MixedGridCardPlaceholder /> : null;
    $[15] = loadingMore;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== gridItems || $[18] !== t3) {
    t4 = <>{gridItems} {t3}</>;
    $[17] = gridItems;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
MixedGridItemsWithReviews.propTypes = {
  allStaticProductData: PropTypes.array,
  data: PropTypes.array,
  from: PropTypes.string,
  gridWithOneCol: PropTypes.bool,
  gridWithReviews: PropTypes.bool,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  isMixedGridTab: PropTypes.bool,
  keyId: PropTypes.string,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  maxCardsCount: PropTypes.number,
  onHoverHandler: PropTypes.func,
  toggleModalView: PropTypes.func
};
export default MixedGridItemsWithReviews;